import { useEffect, useState, useRef } from "react";
import { MapContainer, TileLayer, Circle} from "react-leaflet";

async function geocode(location) {
  const key = `geocode_${location.toLowerCase()}`;

  const cached = localStorage.getItem(key);
  if (cached) {
    return JSON.parse(cached);
  }

  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(location)}`, {
      headers: {
        "User-Agent": "photographer-booking-app"
      }
  });

    if (!res.ok) throw new Error("Geocode failed");

    const data = await res.json();
    if (!data.length) return null;

    const coords = {
      lat: parseFloat(data[0].lat),
      lng: parseFloat(data[0].lon),
    };

    localStorage.setItem(key, JSON.stringify(coords));

    return coords;

  } catch (err) {
    console.error("Geocode error:", err);
    return null;
  }
}

export default function TravelMap({ baseLocation, freeRadiusKm }) {
  const [coords, setCoords] = useState(null);

  const requestedRef = useRef(false);

  useEffect(() => {
    if (!baseLocation || requestedRef.current) return;

    requestedRef.current = true;

    geocode(baseLocation).then(setCoords);
  }, [baseLocation]);

  if (!coords) return null;

  return (
    <MapContainer
      center={[coords.lat, coords.lng]}
      zoom={9}
      style={{ height: "250px", width: "100%" }}
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; OpenStreetMap contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      <Circle
        center={[coords.lat, coords.lng]}
        radius={freeRadiusKm * 1000}
        pathOptions={{
          color: "#2563eb",
          weight: 2,
          fillColor: "#3b82f6",
          fillOpacity: 0.18,
        }}
      />
    </MapContainer>
  );
}